/**
 * Módulo para o Mega Menu
 * Controla a interatividade do mega menu dinâmico
 * Este módulo se auto-inicializa quando o DOM está pronto
 */

(function() {
    'use strict';
    
    // Variável para controlar o estado de scroll
    let isScrolling = false;
    let scrollTimeout;
    
    /**
     * Inicializa a interatividade do mega menu
     */
    function initMegaMenu() {
        // Seletores para os elementos do mega menu
        const navLinksL1 = document.querySelectorAll('.nav-link-l1[data-target-col]'); // Apenas links com data-target-col
        const navLinksL2 = document.querySelectorAll('.nav-link-l2[data-target-l3]'); // Apenas links com data-target-l3
        const l1Columns = document.querySelectorAll('[id$="-col"]');
        const l3Panels = document.querySelectorAll('.l3-menu-panel');
        
        // 1. Seleção de categorias de primeiro nível para mostrar a coluna correspondente
        if (navLinksL1.length > 0) {
            navLinksL1.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault(); // Sempre previne o comportamento padrão para links com data-target-col
                    
                    // Obter o ID da coluna alvo
                    const targetColId = this.getAttribute('data-target-col');
                    
                    // Ocultar todas as colunas
                    l1Columns.forEach(col => {
                        col.style.display = 'none';
                    });
                    
                    // Mostrar a coluna alvo
                    const targetCol = document.getElementById(targetColId);
                    if (targetCol) {
                        targetCol.style.display = 'block';
                        
                        // Ativar o primeiro link L2 dentro desta coluna
                        const firstL2 = targetCol.querySelector('.nav-link-l2');
                        if (firstL2) {
                            // Simular um clique no primeiro link L2
                            firstL2.click();
                        }
                    }
                });
            });
            
            // Ativar o primeiro link L1 por padrão (se não for um link direto)
            if (l1Columns.length > 0) {
                // Mostrar a primeira coluna por padrão
                l1Columns[0].style.display = 'block';
            }
        }
        
        // 2. Seleção de categorias de segundo nível para mostrar o terceiro nível
        if (navLinksL2.length > 0) {
            navLinksL2.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault(); // Sempre previne o comportamento padrão para links com data-target-l3
                    
                    // Obter o ID do painel alvo
                    const targetL3 = this.getAttribute('data-target-l3');
                    
                    // Encontrar todos os links L2 dentro do mesmo menu
                    const parentUl = this.closest('ul');
                    if (parentUl) {
                        const siblingLinks = parentUl.querySelectorAll('.nav-link-l2');
                        
                        // Remover classe ativa de todos os links L2 irmãos
                        siblingLinks.forEach(l => {
                            l.classList.remove('bg-soft-gray');
                        });
                    }
                    
                    // Adicionar classe ativa ao link atual
                    this.classList.add('bg-soft-gray');
                    
                    // Mostrar painel L3 correspondente e ocultar os demais
                    const targetL3Id = this.getAttribute('data-target-l3');
                    if (targetL3Id) {
                        // Encontrar todos os painéis L3 dentro do mesmo mega menu
                        const megaMenu = this.closest('.mega-menu');
                        if (megaMenu) {
                            const relatedPanels = megaMenu.querySelectorAll('.l3-menu-panel');
                            
                            relatedPanels.forEach(panel => {
                                panel.classList.toggle('hidden', panel.id !== targetL3Id);
                            });
                        }
                    }
                });
            });
            
            // Ativar o primeiro link L2 em cada coluna por padrão
            l1Columns.forEach(column => {
                const firstL2 = column.querySelector('.nav-link-l2');
                if (firstL2) {
                    const targetL3Id = firstL2.getAttribute('data-target-l3');
                    
                    // Aplicar classes ativas
                    firstL2.classList.add('bg-soft-gray');
                    
                    // Mostrar o painel L3 correspondente
                    if (targetL3Id) {
                        const megaMenu = column.closest('.mega-menu');
                        if (megaMenu) {
                            const relatedPanels = megaMenu.querySelectorAll('.l3-menu-panel');
                            relatedPanels.forEach(panel => {
                                if (panel.id === targetL3Id) {
                                    panel.classList.remove('hidden');
                                }
                            });
                        }
                    }
                }
            });
        }
    }
    
    /**
     * Controla a posição do mega menu durante o scroll
     * Adiciona a classe 'fixed' quando não há scroll e remove quando há scroll
     */
    function handleMegaMenuPosition() {
        const megaMenus = document.querySelectorAll('.mega-menu');
        
        // Função para atualizar as classes com base no scroll
        function updateMegaMenuPosition() {
            if (isScrolling) {
                megaMenus.forEach(menu => {
                    menu.classList.remove('fixed');
                    menu.classList.add('hidden');
                });
            } else if (window.scrollY === 0) {
                // Adicionar a classe 'fixed' quando não há scroll
                megaMenus.forEach(menu => {
                    menu.classList.add('fixed');
                    menu.classList.remove('hidden');
                });
            }
        }
        
        // Inicializar com a classe 'fixed'
        updateMegaMenuPosition();
        
        // Detectar o evento de scroll
        window.addEventListener('scroll', function() {
            // Marcar que está scrollando
            isScrolling = true;
            
            // Atualizar a posição do mega menu
            updateMegaMenuPosition();
            
            // Limpar o timeout anterior
            clearTimeout(scrollTimeout);
            
            // Definir um novo timeout para detectar quando o scroll parar
            scrollTimeout = setTimeout(function() {
                isScrolling = false;
                updateMegaMenuPosition();
            }, 100); // 100ms após o último evento de scroll
        });
    }
    
    // Inicializar quando o DOM estiver pronto
    document.addEventListener('DOMContentLoaded', function() {
        initMegaMenu();
        handleMegaMenuPosition();
    });
})();
